import {classifications} from './classifications';
import {preClassifications} from './preClassifications';


export class NICEDisposition {
    className: string;
    isActive: boolean;
    dispositionId: number;
    dispositionName: string;
    notes: string;
    classificationId: number;
    classificationName: number;
    systemOutcome: string;
    isPreviewDisposition: boolean;
    // Used for Home widget
    contactCount = 0;
    // Used for SiX
    dependantDispositions: NICEDisposition [];
    // Used for SkillDispositions
    priority: number;

    normalClass: any;
    previewClass: any;
    classes: any;
    d: any;

    constructor(niceDisposition?, type?) {
        if (niceDisposition != null) {
            if (type === null || type === undefined) {
                this.dispositionId = niceDisposition.dispositionId || '';
                this.dispositionName = niceDisposition.dispositionName || '';
                this.isPreviewDisposition = !(niceDisposition.isPreviewDisposition == null || niceDisposition.isPreviewDisposition === false);
                this.notes = niceDisposition.notes || '';
                this.classificationId = niceDisposition.classificationId || 31;
                this.systemOutcome = niceDisposition.systemOutcome || 'CURR';
                this.isActive = (niceDisposition.systemOutcome === 'CURR');
                this.className = this.getClassificationName();
            } else {
                if (type === 'NEW') {
                    this.dispositionName = niceDisposition.dispositionName;
                    this.isPreviewDisposition = !(niceDisposition.isPreviewDisposition == null || niceDisposition.isPreviewDisposition === false);
                    this.notes = niceDisposition.notes;
                    this.classificationId = niceDisposition.classificationId;
                    if (niceDisposition.classificationId === 0) {
                        this.classificationId = 31;
                    }
                    this.isActive = niceDisposition.isActive;
                    this.className = this.getClassificationName();

                } else {
                    // UPDATE
                    this.dispositionId = niceDisposition.dispositionId;
                    this.dispositionName = niceDisposition.dispositionName;
                    this.isPreviewDisposition = !(niceDisposition.isPreviewDisposition == null || niceDisposition.isPreviewDisposition === false);
                    this.notes = niceDisposition.notes;
                    // this.classificationId = niceDisposition.classificationId;
                    this.classificationId = niceDisposition.classificationId || 0;
                    if (niceDisposition.classificationId === 0) {
                         this.classificationId = 31;
                    }
                    this.isActive = niceDisposition.isActive;
                    this.className = this.getClassificationName();
                    // if (niceDisposition.isActive) {
                    //     this.systemOutcome = 'CURR';
                    // } else {
                    //     this.systemOutcome = 'DISC';
                    // }
                }
            }
        } else {
            this.dispositionName = '';
            this.isPreviewDisposition = false;
            this.notes = '';
            this.classificationId = 0;
            this.systemOutcome = 'CURR';
            this.className = this.getClassificationName();
            this.isActive = true;
        }

    }
    getClassificationName(): string {
        this.normalClass = classifications;
        this.previewClass = preClassifications;
        if (this.classificationId === 31) {
            return 'None';
        } else {
            if (this.isPreviewDisposition) {
                this.classes = this.previewClass;
            } else {
                this.classes = this.normalClass;
            }
            let d;
            for (d of this.classes) {
                if (d.vlaue === this.classificationId) {
                    return d.viewValue;
                }
            }
        }
    }
}

